import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { OrganizationHoldingResponseDto } from '@domain/organization-holding/dtos/organization-holding.response.dto';
import { GetOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/get-organization-holding.request.dto';
import { CreateOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/create-organization-holding.request.dto';
import { ListOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/list-organization-holding.request.dto';
import { PageableResponse } from '@core/interface/pageable.interface';
import { UpdateOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/update-organization-holding.request.dto';
import { UpdateStateOrganizationHoldingRequestDto } from '@domain/organization-holding/dtos/update-state-organization-holding.request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
    providedIn: 'root',
})
export class OrganizationHoldingService extends UrlBuilder {
    constructor(private http: HttpClient) {
        super('organization/holding');
    }

    create(request: CreateOrganizationHoldingRequestDto) {
        const queryUrl = `${this.getApiUrl()}`;
        return this.http.post<ApiResponse<OrganizationHoldingResponseDto>>(
            queryUrl,
            request,
        );
    }

    update(request: UpdateOrganizationHoldingRequestDto) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/${refId}`;
        return this.http.put<ApiResponse<OrganizationHoldingResponseDto>>(
            queryUrl,
            request,
        );
    }

    updateState(request: UpdateStateOrganizationHoldingRequestDto) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/${refId}/state`;
        return this.http.patch<ApiResponse<OrganizationHoldingResponseDto>>(
            queryUrl,
            request,
        );
    }

    show(request: RefId) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/show/${refId}`;
        return this.http.get<ApiResponse<OrganizationHoldingResponseDto>>(
            queryUrl,
            {},
        );
    }

    list(request: ListOrganizationHoldingRequestDto) {
        const queryUrl = `${this.getApiUrl()}/list`;
        return this.http.get<
            ApiResponse<PageableResponse<OrganizationHoldingResponseDto>>
        >(queryUrl, { params: { ...request } });
    }

    get(request: GetOrganizationHoldingRequestDto) {
        const queryUrl = `${this.getApiUrl()}/get`;
        return this.http.get<ApiResponse<OrganizationHoldingResponseDto[]>>(
            queryUrl,
            { params: { ...request } },
        );
    }
}
